import { createFileRoute } from '@tanstack/react-router';
import { HStack, Spacer } from '@/components/Layout';
import StepperNavigation from '@/components/Navigation/StepperNavigation';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { AddInboundAggregateDataPipelineForm } from './-components/AddInboundAggregateDataPipelineForm';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/')({
  component: AddInboundAggregateDataPipeline
});
function AddInboundAggregateDataPipeline() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.dataConnector.inboundAggregateDataPipeline.add'
  });
  useDocumentTitle(t('pageTitle'));
  const sections = [{
    key: 'basicInfo',
    hash: 'basic-info',
    label: t('stepper.basicInfo'),
    completed: false,
    error: false
  }];
  return <HStack className="w-full p-6 h-[calc(100vh-64px)]">
      <StepperNavigation className="sticky h-full" link={{
      hash: 'basic-info',
      to: '/settings/data-connector/inbound/aggregate-data-pipeline/add'
    }} title={t('title')} sections={sections} />
      <Spacer variant="m" />
      <AddInboundAggregateDataPipelineForm />
    </HStack>;
}